define(function (require) {
    const tpl = require('civicsViews/share_url/templates/t_lov_share_url_modal.hbs');
    const send_url_cpv = require('civicsViews/send_email/v_cpv_email');
    const url_itv = require('civicsViews/share_url/v_itv_url');
    const Radio = require('backbone.radio');
  	const Channel = Radio.channel('SendEmailChannel');
	const general_utilities = require('civicsUtils/general_utilities');

    const ViewManager = require('civicsUtils/view_manager');

    return Marionette.LayoutView.extend({
        template: tpl,
        ui: {
            shareUrlModal: '.bbm-modal.share-url-modal',
            shareUrlModalContainer: '.share-url-modal-container',
            sendContent: '.send-content',
            urlItem: '.url-item',
            urlReceipientContent: '.url-recipient-content',
            cancelButton: '.cancel-button',
            sendEmailButton: '.send-email-button'
        },
        events: {
            'click @ui.sendEmailButton': 'sendEmailClicked',
            'click @ui.cancelButton': 'closeEmailModal',
            'click .bbm-btn-close': 'closeEmailModal'
        },
        childEvents: {},
        regions: {
            recipientRegion: "@ui.urlReceipientContent",
            urlRegion: "@ui.urlItem",
        },
        initialize: function (options) {
            this.config = options.config;
            this.modalRegion = options.modalRegion; // reuse modalRegion from the parent view
            this.portletName = options.portletName; // target portletName to find its corresponding labels
            this.emailModel = options.emailModel;
            this.URLPath = options.URLPath;
            this.URLParams = options.URLParams;
            this.usesFullURLPath = options.usesFullURLPath;
            this.formDescriptionKey = options.formDescriptionKey != null ? options.formDescriptionKey: 'FORM_DESCRIPTION';

            //setup the labels
            if (this.portletName && this.portletName.length > 0) {
                var localizationKey = this.portletName.toUpperCase();

                this.commonLabel = {
                    'modal_title': i18n.t('CIVICS.' + localizationKey + '.SHARE_URL.MODAL_TITLE_SHARE'),
                    'copy_url_description': i18n.t('CIVICS.' + localizationKey + '.SHARE_URL.COPY_URL_DESCRIPTION'),
                    'form_description': i18n.t('CIVICS.' + localizationKey + '.EMAIL.'+ this.formDescriptionKey),
                    'sendEmail_buttonDesc': i18n.t('CIVICS.' + localizationKey + '.EMAIL.SEND'),
                    'shareUrl_success': i18n.t('CIVICS.' + localizationKey + '.SHARE_URL.SUCCESS'),
                    'emailRequired': i18n.t('CIVICS.' + localizationKey + '.SHARE_URL.EMAIL_REQUIRED')
                }
            }

            this.listenTo(Channel,'showEmptyError',this.showEmptyError);
        },
        onRender: function () {
            this.ui.sendContent.detach().prependTo(this.ui.shareUrlModal);

            this.urlItemView = new url_itv({
                config: this.config,
                portletName: this.portletName,
                URLPath: this.URLPath,
                URLParams: this.URLParams,
                usesFullURLPath: this.usesFullURLPath
            });

            this.sendUrlCompView = new send_url_cpv({
                config: this.config,
                portletName: this.portletName,
                allowEmptyData: true
            });

        },
        onShow: function () {
            this.urlRegion.show(this.urlItemView);
            this.recipientRegion.show(this.sendUrlCompView);
        },
        closeEmailModal: function () {
            if (this.modalRegion) {
                this.modalRegion.hideModal();
            } else {
                this.destroy();
            }
        },
        sendEmailClicked: function () {
            var self = this;
            ViewManager.resetErrorMessages(this);
            ViewManager.loading(true);
            this.sendEmailPromise = $.Deferred();
            var isDataValid = this.sendUrlCompView.saveFormData(false);
            if (isDataValid) {
                this.sendEmail();
            } else {
                //if has error still resolve this ..
                self.sendEmailPromise.resolve();
            }

            $.when(self.sendEmailPromise).done(function () {
                if (isDataValid) {
                    self.closeEmailModal();
                }
                ViewManager.loading(false);
            });
        },
        sendEmail: function () {
            var self = this;
            var promises = [];
            var sentEmails = [];

            var inputParam = this.emailModel.get('InputParameters');
            if (inputParam != undefined && inputParam.length > 0) {
                inputParam.push({
                    value: this.urlItemView.shareUrl
                });
            }

            _.each(this.sendUrlCompView.collection.models, function (model) {
                if (model.emailAddressCollection && model.emailAddressCollection.length > 0) {
                    _.forEach(model.emailAddressCollection, email => {
                        if (email && sentEmails.indexOf(email) == -1) {
                            var def = new $.Deferred();
                            sentEmails.push(email);

                            self.emailModel.set('emailAddress', email.trim());

                            self.emailModel.save(null, {
                                success: _.bind(function (model, response) {
                                    def.resolve();
                                    self.emailModel.set('emailAddress', '') //reset after.
                                }, this),
                                error: _.bind(function (model, response, options) {
                                    def.reject();
                                    self.emailModel.set('emailAddress', '') //reset after.
                                    ViewManager.errorToWindow(response, this);
                                    ViewManager.loading(false);
                                }, this),
                            });

                            promises.push(def);
                        }
                    });
                }
            });

            $.when.apply($, promises).done(function (response, status, xhrResponse) {
                general_utilities.civicsToastPop(self.commonLabel.shareUrl_success, "success");
                self.sendEmailPromise.resolve();
            }).fail(function (response, status, xhrResponse) {
                ViewManager.loading(false);
            });
        },
        showEmptyError: function() {
          ViewManager.errorToWindow({
            validationError: {
              emailRequiredError: this.commonLabel.emailRequired
            }
          },this);
        },
        templateHelpers: function () {
            var self = this;
            return {
                modal_title: self.commonLabel.modal_title,
                copy_url_description: self.commonLabel.copy_url_description,
                form_description: self.commonLabel.form_description,
                sendEmail_buttonDesc: self.commonLabel.sendEmail_buttonDesc
            };
        }
    });
});
